var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#car_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009E7B",
    d: "M20.55 9.9h-.576l-3.909-4.887a2.3 2.3 0 0 0-1.796-.863H6.582a2.3 2.3 0 0 0-2.136 1.446L2.725 9.98A2.295 2.295 0 0 0 1 12.2v4.025c0 .318.257.575.575.575H3.3a3.45 3.45 0 1 0 6.9 0h4.6a3.45 3.45 0 1 0 6.9 0h1.724a.575.575 0 0 0 .576-.575V13.35a3.45 3.45 0 0 0-3.45-3.45m-13.8 8.625A1.727 1.727 0 0 1 5.025 16.8c0-.951.773-1.725 1.725-1.725.95 0 1.725.774 1.725 1.725S7.7 18.525 6.75 18.525M9.337 9.9H5.202l1.38-3.45h2.755zm1.725 0V6.45h3.207l2.76 3.45zm7.188 8.625a1.727 1.727 0 0 1-1.726-1.725c0-.951.774-1.725 1.726-1.725.95 0 1.724.774 1.724 1.725s-.773 1.725-1.724 1.725"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "car_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgCar;